module.exports = __webpack_public_path__ + "img/09acd09.png";